'use strict';

bbw.shared.ProfileCtrl = ngtk.controller.Base.extend({

    $inject: ['$scope', 'bbw.LocationSvc', '$rootScope', 'bbw.LayoutTypeSvc', '$fancyModal', 'rpcClient', '$attrs', 'setWindowTitle', 'bbw.RedirectSvc', 'growl'],

    include: [bbw.shared.MobileMenuTabsTrait],

    _defaultTab: 'menu',

    _tabsWithIds: ['blog'],

    _getTabNames: function() {
        return {
            menu: 'menu',
            profile: 'profile',
            photos: 'photos',
            wall: 'wall',
            talk: 'talk',
            blog: 'blog'
        };
    },

    _initContext: function() {
        if (window.location.hash.substr(0, 2) === '#@') {
            this._context = window.location.hash.substr(2) || null;
        }
    },

    _getTabLocStates: function() {
        var states = this._getTabNames();
        this._tabsWithIds.forEach(function(key) {
            states[key] = states[key] + '{id:[0-9]*}';
        });
        return states;
    },

    _isTabWithIdState: function(state) {
        return (this._tabsWithIds.indexOf(state.name) >= 0 && state.args.id > 0);
    },

    _onMobileBack: function() {
        var state = this._tabsLocState.getCurrentState();

        if (this._context && this._context === 'blogs') {
            this._bbwRedirectSvc.redirectTo('blogs');
            return;
        }

        if (this._isTabWithIdState(state) && this.$scope.userPostId) {
            this._tabsLocState.setState(undefined, {});
        } else {
            this._tabsLocState.setState('menu');
        }
    },

    _onMobileTabsStateChanged: function(state) {
        if (this._isTabWithIdState(state)) {
            this.$scope.userPostId = state.args.id > 0 ? state.args.id : undefined;
        } else {
            this.$scope.userPostId = undefined;
        }
        this._updateWindowTitle();
    },

    _init: function() {
        this._initContext();
        this._initTabs();
    },

    _updateWindowTitle: function() {
        var titleType = this._tabsLocState.getCurrentState().name;
        if (titleType == 'menu') {
            titleType = undefined;
        }
        var title = this.$attrs.userNickname + ', ' + this.$attrs.userAge;
        if (titleType) {
            var titleSuffix = bbw.messages.profile_area[titleType];
            if (titleSuffix) {
                title += ': ' + titleSuffix;
            }
        }
        this._setWindowTitle(title);
    },

    _initTabs: function() {
        return this._initMobileMenuTabs().then(this._updateWindowTitle.bind(this));
    },

    sendAbuse: function() {
        var user = {
            id: this.$attrs.userId,
            nickname: this.$attrs.userNickname
        };
        return this._showAbuseModal(user).then(this._doSendAbuse.bind(this, user))
            .then(function() {
                this._growl.success('abuse_sent');
            }.bind(this))
            .catch(function(e) {
                e && this._growl.error(e.error || e);
            }.bind(this));
    },

    _doSendAbuse: function(user, abuse) {
        var args = abuse || {};
        args.user_id = user.id;
        return this._rpcClient.post('profile/abuse', args).execute();
    },

    _showAbuseModal: function(user) {
        return this._showModal('content-abuse', {
            abuse: {},
            reasons: bbw.model.Abuse.getReasonsList('profile').map(function(r) {
                r.reason_title = bbw.messages.abuse[r.reason];
                return r;
            }),
            reasonRequiresDesc: bbw.model.Abuse.requiresDesc,
            context: {
                type: 'profile',
                action: 'abuse',
                user: user
            }
        });
    },

    _showModal: function(action, scope, init) {
        var deferred = this.$q.defer();
        var $scope = this.$scope.$new();
        angular.extend($scope, scope || {});
        this.$fancyModal.open({
            templateUrl: bbw.templateUrl(action + '.html'),
            scope: $scope,
            controller: ['$scope', function($scope) {
                if (angular.isFunction(init)) {
                    init($scope);
                }
                $scope.ok = function(value) {
                    deferred.resolve(value);
                    $scope.$modal.close();
                };
                $scope.cancel = function() {
                    deferred.reject();
                    $scope.$modal.close();
                };
            }]
        });
        return deferred.promise;
    }

});
